import type { WindowFrame } from '@omnia/shared';
import { snapToGrid } from './store.ts';

export type Edge = 'n' | 's' | 'e' | 'w' | 'ne' | 'nw' | 'se' | 'sw';

/** A window follows exactly one finger; later touches on the same window must not steal or corrupt its basis. */
export function ownsGesture(gesture: { pointerId: number } | null, pointerId: number) {
  return gesture !== null && gesture.pointerId === pointerId;
}

export function resizeFrame(start: WindowFrame, edge: Edge, dx: number, dy: number, minWidth: number, minHeight: number) {
  let { x, y, width, height } = start;
  if (edge.includes('e')) width = Math.max(minWidth, snapToGrid(start.width + dx));
  if (edge.includes('s')) height = Math.max(minHeight, snapToGrid(start.height + dy));
  // West/north edges move the origin, so clamp before deriving it to keep the opposite edge fixed.
  if (edge.includes('w')) {
    width = Math.max(minWidth, snapToGrid(start.width - dx));
    x = start.x + start.width - width;
  }
  if (edge.includes('n')) {
    height = Math.max(minHeight, snapToGrid(start.height - dy));
    y = start.y + start.height - height;
  }
  return { x, y, width, height } satisfies WindowFrame;
}
